import {featureFlags} from '@dms/feature-flags';

import {VehicleForm as VFKit} from '../VehicleForm';

export function EngineSpecsGroup() {
  return (
    <>
      <VFKit.SimpleNumericField name="power" />
      <VFKit.ShowWhen whenFeatureEnabled={featureFlags.CORE_MAX_POWER}>
        <VFKit.SimpleNumericField name="maximalPower" />
      </VFKit.ShowWhen>
      <VFKit.SimpleNumericField name="engineVolume" />
      <VFKit.SimpleNumericField name="cylinderCount" />
    </>
  );
}
